import { AncillaryBaggageDetails, AncillaryBaggageInfo, JourneyAncillary } from '@/src/types/itinerary'
import { isEmpty } from '../../generalUtils/isEmpty'
import { AncillaryDataStructure, createSegmentInfo, isValidOriginDestination } from './common'

// ================================
// BAGGAGE PROCESSING
// ================================

/**
 * Sorts baggage by quantity
 */
const sortBaggageByQuantity = (a: AncillaryBaggageInfo, b: AncillaryBaggageInfo): number => {
    const quantityA = a?.baggageList?.[0]?.quantity || 0
    const quantityB = b?.baggageList?.[0]?.quantity || 0
    return quantityA - quantityB
}

/**
 * Processes baggage ancillaries from journey level
 */
export const getBaggageAncillaries = (journeyAncillaries: JourneyAncillary[]) => {
    const baggageAncillaries: AncillaryDataStructure<AncillaryBaggageInfo[]> = {
        availableSegments: [],
        segmentWiseAncillaryData: {}
    }

    if (isEmpty(journeyAncillaries) || !Array.isArray(journeyAncillaries)) {
        return { baggageAncillaries, isBaggageAvailable: false }
    }

    journeyAncillaries.forEach(journeyAncillary => {
        const { baggageAncillary } = journeyAncillary || {}
        const { baggageDetails = [] } = baggageAncillary || {}

        if (isEmpty(baggageDetails)) {
            return
        }

        baggageDetails.forEach((baggageDetail: AncillaryBaggageDetails) => {
            const { baggageInfos = [], originDestinationInfo } = baggageDetail

            if (
                !Array.isArray(baggageInfos) ||
                isEmpty(baggageInfos) ||
                !isValidOriginDestination(originDestinationInfo)
            ) {
                return
            }

            const segmentInfo = createSegmentInfo(originDestinationInfo.from, originDestinationInfo.to)

            baggageAncillaries.availableSegments.push(segmentInfo)

            // Sort baggage by quantity
            const sortedBaggageInfos = [...baggageInfos].sort(sortBaggageByQuantity)
            baggageAncillaries.segmentWiseAncillaryData[segmentInfo.key] = sortedBaggageInfos
        })
    })

    return {
        baggageAncillaries,
        isBaggageAvailable: baggageAncillaries.availableSegments.length > 0
    }
}

/**
 * Finds baggage object by code within a specific segment
 */
export const findBaggageByCode = (
    baggageCode: string,
    segmentKey: string,
    baggageAncillaries: AncillaryDataStructure<AncillaryBaggageInfo[]>
): AncillaryBaggageInfo | null => {
    const segmentBaggageData = baggageAncillaries.segmentWiseAncillaryData[segmentKey]

    if (!Array.isArray(segmentBaggageData)) {
        return null
    }

    for (const baggageInfo of segmentBaggageData) {
        if (baggageInfo?.baggageCode === baggageCode) {
            return baggageInfo
        }
    }

    return null
}
